export default {
  MY_AVAILABILITY: {
    TITLE: `Mes disponibilités`,
    SUMMARY: `Affichez, modifiez et créez vos disponibilités.`
  },
  CANCEL_MODAL: {
    TITLE: `Êtes vous certain de vouloir supprimer cette disponibilité ?`,
    SUMMARY: `Une fois supprimée, une disponibilité ne peut pas être récupérée.`,
    PRIMARY_ACTION: `Supprimer la disponibilité`
  },
  CREATE_AVAILABILITY: `Créer une disponibilité`,
  TEMPORARY: `Temporaire`,
  NO_AVAILABILITY: 'Aucune disponibilité à afficher.',
  CREATED_ON: `Créée le`,
  LAST_UPDATED_ON: `Dernière modification le `,
  CONTRACT_TYPE_PREVENTS_UPDATING: `Un ou plusieurs de vos contrats ou permissions vous empêche de modifier vos disponibilitées, veuillez communiquer avec votre gestionnaire afin d'avoir plus d'information.`,
  AVAILABILITY_IN_PAST: `Cette disponibilité est déjà commencée et ne peut pas être modifiée, veuillez la dupliquer et en créer une nouvelle pour effectuer des changements.`,
  AVAILABILITY_APPROVED: `Cette disponibilité est déjà été approuvée et ne peut pas être modifiée, veuillez la dupliquer et en créer une nouvelle pour effectuer des changements.`
}
